


























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AppDialog extends Vue {
  @Prop() readonly size!: 'xsmall' | 'small' | 'medium' | 'large' | 'flexible' // default size is medium
  @Prop() readonly hideCancel!: boolean // hide or show Cancel button, default is false
  @Prop() readonly hideFooter!: boolean // hide or show footer slot, default is false
  @Prop() readonly customWidth?: string // to define width of the dialog body

  get showCancel () {
    return this.hideCancel ? !this.hideCancel : true
  }

  get showFooter () {
    return this.hideFooter ? !this.hideFooter : true
  }

  get sizeClass () {
    return this.size ? this.size : 'medium'
  }

  created () {
    this.$emit('open')
  }
}
